export const CONTEXT_SWITCH_REQUEST = 'app/CONTEXT_SWITCH_REQUEST';
export const CONTEXT_SWITCH_RECEIVE = 'app/CONTEXT_SWITCH_RECEIVE';

export const requestContextSwitch = (message = 'Loading…') => ({
  type: CONTEXT_SWITCH_REQUEST,
  message,
});

export const receiveContextSwitch = () => ({ type: CONTEXT_SWITCH_RECEIVE });
